import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Brightness2Icon from "@mui/icons-material/Brightness2";

import MaterialBox from "../../../../components/MaterialBox";
import {
  setMiniSidenav,
  setTransparentNavbar,
  useMaterialUIController,
} from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Badge, Box, InputBase, useMediaQuery } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../../../context/AuthContext/AuthContextProvider";
import Button from "@mui/material/Button";
import AppsIcon from "@mui/icons-material/Apps";
import MenuItem from "@mui/material/MenuItem";
import crmlogo from "../../../../assest/productimage/crm.png";
import hrmslogo from "../../../../assest/productimage/hrms.png";
import accountsogo from "../../../../assest/productimage/accounts.png";
import projectlogo from "../../../../assest/productimage/project.png";
import warelogo from "../../../../assest/productimage/warehouse.png";
import qalogo from "../../../../assest/productimage/qa.png";
import "./index.css";
import MaterialInput from "../../../../components/MaterialInput";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationBar from "./components/NotificationBar";
import ZPatternSocialPopup from "./components/waffle";

function DashboardNavbar({ tableData, absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } =
    controller;
  const [anchorEl, setAnchorEl] = useState(null);
  const newopen = Boolean(anchorEl);
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const isNotificationOpen = Boolean(notificationAnchor);
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  
  const { currentUser, logout } = useAuth();
  const [noSearch, setNoSearch] = useState(false);
  const [Open, setOpen] = useState(false);
  const [ length, setLength ] = useState(0)
  const [searchQuery, setSearchQuery] = useState("");
  
  
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const onClose = () => {
    handleMiniSidenav();
  };

  const [user, setUser] = useState({
    name: "Ajith Kumar",
    picture: "",
    email: "",
  });
  const [pageState, setPageState] = useState({
    state: "init",
  });

  useEffect(() => {
    const getUser = () => {
      setUser({
        name: currentUser.username,
        email: user.email,
        picture: user.picture,
      });
      setPageState({
        state: "default",
      });
    };
    getUser();
  }, []);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);


  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const open = Boolean(openMenu);

  // setIsCollapsed(!isCollapsed);
  // onClose();
  // Render the notifications menu


  const handleNotificationClick = (event) => {
    setNotificationAnchor(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchor(null);
  };

  // //Search Function
  // const handleSearch = (event) => {
  //   const query = event.target.value;
  //   setSearchQuery(query);

  //   const filtered = tableData.filter((row) =>
  //     Object.values(row).some((value) =>
  //       String(value).toLowerCase().includes(query.toLowerCase())
  //     )
  //   );    
  //   setFilteredRows(filtered);
  // };



  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={
          <>
            {user.picture ? (
              <Avatar
                alt={user.name}
                src={user.picture}
                sx={{ width: 24, height: 24 }}
              />
            ) : (
              <MaterialAvatar
                size="sm"
                {...stringAvatar(user.name || user.email || "UNNAMED")}
              />
            )}
          </>
        }
        title={user.name || user.email}
      />
      <NotificationItem
        id="logout"
        onClick={signOut}
        icon={<LogoutIcon />}
        title={"Logout"}
      />
    </Menu>
  );

  const signOut = () => {
    // navigate('/')
    logout();
  
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      // position="navbarType"
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {pageState.state === "default" && (
          <>
            <MaterialBox
              color="inherit"
              mb={{ xs: 1, md: 0 }}
              sx={(theme) => navbarRow(theme, { isMini })}
            >
              <MaterialBox 
              display="flex">
                {isMobile && (
                  <IconButton onClick={handleMiniSidenav}>
                    <MenuIcon sx={{ color: "#003051" }} />
                  </IconButton>
                )}
                {/* <Icon
                  fontSize="medium"
                  onClick={handleMiniSidenav}
                  sx={{ cursor: "pointer" }}
                >
                  {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                </Icon> */}
                <MaterialBox
                  sx={{
                    fontSize: "14px",
                    color: "#6a0dad",
                    fontWeight: "bold",
                    textTransform: "capitalize"
                  }}
                  ml={1}
                >
                  {/* <Breadcrumbs
                    // icon={<HomeIcon />}
                    title={route[route.length - 1]}
                    route={route}
                    light={light}
                  /> */}
                  <span
                    onClick={() => navigate("/dashboard")}
                    style={{ cursor: "pointer", color: "#6a0dad" }}
                  >
                    Home
                  </span>
                  &nbsp;/&nbsp;
                  <span
                  style={{ cursor: "pointer", color: "#6a0dad" }}
                >
                  {route.join(" / ")}
                </span>

                </MaterialBox>
              </MaterialBox>
            </MaterialBox>

            <div style={{ display: "flex", alignItems: "center" }}>
              <MaterialBox ml="auto" px={1}>
                {/* {noSearch ? null : ( */}
                  {/* <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #E0E0E0",
                      borderRadius: "50px", // Fully rounded corners
                      padding: "0px 10px", // Inner padding
                      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow
                      "&:hover": {
                        borderColor: "#D0D0D0",
                      },
                    }}
                  > */}
                    {/* Search Icon */}
                    {/* <IconButton sx={{ p: 0 }}>
                      <SearchIcon sx={{ color: "#B0B0B0" }} />
                    </IconButton> */}

                    {/* Input Field */}
                    {/* <InputBase
                      placeholder="Search"
                      value={searchQuery}
                      onChange={handleSearch}
                      sx={{
                        ml: 2,
                        flex: 1,
                        fontSize: "16px",
                        color: "#333333",
                        borderWidth: 0,
                      }}
                    /> */}
                  {/* </Box> */}
                {/* )} */}
              </MaterialBox>
              <IconButton
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  color: "#000",
                  mr: 1,
                  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                <Brightness2Icon />
              </IconButton>
              <IconButton
                onClick={handleNotificationClick}
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  color: "#000",
                  mr: 1,
                  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                  },
                }}
              >
                <Badge
                  color="error"
                  // variant="dot"
                  variant={length > 0 ? "dot" : undefined} 
                  onClick={() => setOpen(true)}
                  // badgeContent={unreadCount}
                  // invisible={unreadCount === 0}
                >
                  <NotificationsIcon />
                </Badge>

                </IconButton>
                <NotificationBar
                length={length}
                setLength={setLength}
                anchorEl={notificationAnchor}
                open={isNotificationOpen}
                onClose={() => setNotificationAnchor(null)}
                />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "8px",
                }}
              >
                {/* <AppsIcon
                  id="basic-button"
                  aria-controls={newopen ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={newopen ? "true" : undefined}
                  onClick={handleClick}
                  sx={{ transform: "scale(1.8)", cursor: "pointer" }}
                /> */}
                <ZPatternSocialPopup/>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={newopen}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{ marginTop: "20px", marginRight: "30px" }}
                >
                  <div style={{ height: "max-content", width: "280px" }}>
                    <div className="productimg-box">
                      <div>
                        <img src={projectlogo} />
                        <p>Projects</p>
                      </div>
                      <div>
                        <img src={warelogo} />
                        <p>Warehouse</p>
                      </div>
                      <div>
                        <img src={qalogo} />
                        <p>Quality</p>
                      </div>
                    </div>
                    <div className="productimg-box">
                      {/* <div>
                        <img src={crmlogo} />
                        <p>CRM</p>
                      </div> */}

                      <a href="http://94.136.187.221:2009/" target="_blank">
                        <div>
                          <img src={hrmslogo} />
                          <p>HRMS</p>
                        </div>
                      </a>
                      <div>
                        <img src={accountsogo} />
                        <p>Accounts</p>
                      </div>
                    </div>
                  </div>
                </Menu>
              </div>

              {isMini ? null : (
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    <MaterialAvatar
                      alt={user.name}
                      src={user.picture}
                      sx={{ width: 35, height: 35 }}
                    />
                  </IconButton>
                  {renderMenu()}
                </MaterialBox>
              )}
            </div>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
